import { z } from "zod";
/**
 * `POST /v1/admin/variants/:id/adjust-stock` request body. The field names
 * `delta` and `reason` are single-word so the snake_case rule degenerates
 * to "no transformation". `delta` is a non-zero signed integer (negative
 * adjusts down, positive adjusts up). The DB CHECK constraint
 * `inventory_adjustments_delta_nonzero` enforces this at the schema level
 * too; the Zod schema is the first line of defence so the request
 * surfaces as a 422 rather than reaching the DB.
 *
 * `reason` is free-form up to 500 chars (mirrors `RejectCustomerBody.reason`
 * + `CreateRefundBody.reason`). The DB CHECK constraint
 * `inventory_adjustments_reason_nonempty` enforces non-empty.
 */
export const AdjustStockBody = z.object({
    delta: z.number().int(),
    reason: z.string().min(1).max(500),
});
/**
 * `GET /v1/admin/variants/:id/adjustments` query schema. Mirrors the
 * T3 customers + T5 orders pattern: `z.coerce.number()` for `limit` so a
 * malformed `?limit=abc` surfaces as a 422 via `Zod.parse(query)` at the
 * controller boundary, NOT as a silent fall-back to the default. The
 * cap of 100 reflects the inventory-adjustment list's narrower scale
 * vs. the 200 cap on customers/orders/products.
 */
export const ListAdjustmentsQuery = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(50),
    cursor: z.string().optional(),
});
